import { LayerWrapper } from '../LayerWrapper';
import { Ajax } from '@shared/Ajax';
import WebGLPointsLayer from 'ol/layer/WebGLPoints';
import VectorSource from 'ol/source/Vector';
import { PipeFeatureFactory } from '@openlayers/pipes/PipeFeatureFactory';
import { removeFeaturesBySource } from '../ol-utils';

export class PipesLayer extends LayerWrapper<IPipeNetwork> {
    featureType: FeatureType = 'pipe';

    arrowsLayer: WebGLPointsLayer<any> = new WebGLPointsLayer({
        source: new VectorSource() as any,
        style: {
            'shape-points': 3,
            'shape-radius': 5,
            'shape-displacement': [0, -6],
            'shape-rotation': ['get', 'rotation', 'number'],
            'shape-fill-color': 'black',
            'shape-rotate-with-view': true,
        },
    });
    arrowsLayerAdded = false;

    constructor(opts) {
        super(opts);

        const arrowsSource = this.arrowsLayer.getSource() as VectorSource;
        const addOrRemoveDeviationsLayer = _.debounce(() => {
            if (arrowsSource.isEmpty()) {
                this.removeArrowsLayer();
            } else {
                this.addArrowsLayer();
            }
        }, 10);
        arrowsSource.on('addfeature', addOrRemoveDeviationsLayer);
        arrowsSource.on('removefeature', addOrRemoveDeviationsLayer);
    }

    fetchAndDrawFile(modelId?: any) {
        (this.arrowsLayer.getSource() as VectorSource).clear();

        return Ajax({
            url: `api/1/file/${modelId}/pipe_networks.json`,
        }).done((resp: { pipeNetwork: IPipeNetwork }) => {
            resp.pipeNetwork.modelId = modelId;
            const featuresResult = this.drawAll([resp.pipeNetwork]);
            featuresResult.features.forEach(f => {
                this.arrowsLayer.getSource().addFeatures(PipeFeatureFactory.makeArrowFeatures(f));
            });
        });
    }

    removeFeaturesBySource(source: FeatureSource, silent: boolean = true) {
        removeFeaturesBySource(this.arrowsLayer.getSource() as VectorSource, source, false);
        super.removeFeaturesBySource(source, silent);
    }

    addArrowsLayer = () => {
        if (this.arrowsLayerAdded || this.arrowsLayer.getSource().isEmpty()) return;

        this.arrowsLayerAdded = true;
        this.map.addLayer(this.arrowsLayer);
        this.arrowsLayer.setZIndex(this.layer.getZIndex() - 1);
    };

    removeArrowsLayer = () => {
        this.arrowsLayerAdded = false;
        this.map.removeLayer(this.arrowsLayer);
    };

    setLayerOpacity = (opacity: number) => {
        if (typeof opacity === 'number') {
            opacity = utils.clamp(0.04, opacity / 100, 1);
            this.layer.setOpacity(opacity);
            this.arrowsLayer.setOpacity(opacity);
            this.layerOpacity = opacity;
        } else {
            this.layer.setOpacity(1);
            this.arrowsLayer.setOpacity(1);
            this.layerOpacity = 100;
        }
    };
}
